const ZERO = 0;

export default function head<T>(attr: T[] | string): T | string {
  return attr[ZERO];
}
